/*
 * callec-plp.js — コレクションページ改修 S-037 段階1(2026-10-06)
 * - A 訴求枠: 説明文の折りたたみ(収まらないときだけ「続きを読む」を出す)
 * - B 上の階層帯: 現在地のチップが見える位置まで横に寄せる(動きなし)、右端まで来たらフェードを消す
 * - 計測: Shopify.analytics.publish('callec:...') でカスタムピクセルに渡す(GA4 へはピクセル側で送る)
 * セクションの再描画(テーマエディター)にも対応するため、初期化は要素ごとに1回だけ行う。
 */
(function () {
  'use strict';

  if (window.__callecPlp) {
    window.__callecPlp.init(document);
    return;
  }

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        var m = location.pathname.match(/\/collections\/([^/?#]+)/);
        var t = document.body ? document.body.className.match(/template-[\w-]+/) : null;
        Shopify.analytics.publish(
          name,
          Object.assign({}, data, {
            collection_handle: m ? decodeURIComponent(m[1]) : '',
            template: t ? t[0] : ''
          })
        );
      }
    } catch (e) {
      /* 計測の失敗で表示を止めない */
    }
  }

  function initDesc(scope) {
    scope.querySelectorAll('[data-cplp-desc]').forEach(function (desc) {
      if (desc.dataset.cplpReady) return;
      desc.dataset.cplpReady = '1';
      var btn = desc.parentNode.querySelector('[data-cplp-desc-more]');
      if (!btn) return;
      var closed = btn.querySelector('[data-label-closed]');
      var open = btn.querySelector('[data-label-open]');

      function measure() {
        if (desc.classList.contains('is-open')) return;
        /* 収まっているならボタンを出さない */
        btn.hidden = desc.scrollHeight <= desc.clientHeight + 2;
      }
      measure();
      window.addEventListener('resize', measure, { passive: true });

      btn.addEventListener('click', function () {
        var willOpen = !desc.classList.contains('is-open');
        desc.classList.toggle('is-open', willOpen);
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (closed) closed.hidden = willOpen;
        if (open) open.hidden = !willOpen;
        if (willOpen) publish('callec:plp_desc_expand', {});
      });
    });
  }

  function initBand(scope) {
    scope.querySelectorAll('[data-cplp-band]').forEach(function (band) {
      if (band.dataset.cplpReady) return;
      band.dataset.cplpReady = '1';
      var track = band.querySelector('[data-cplp-band-track]');
      if (!track) return;

      function updateEnd() {
        band.classList.toggle('is-end', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
      }

      /* 現在地のチップが見えていなければ、左に少し余白を残して寄せる(動きなし) */
      var cur = track.querySelector('.is-current');
      if (cur) {
        var left = cur.offsetLeft - track.offsetLeft;
        var right = left + cur.offsetWidth;
        if (right > track.clientWidth - 24) {
          track.scrollLeft = Math.max(0, left - 48);
        }
      }
      updateEnd();
      track.addEventListener('scroll', updateEnd, { passive: true });
      window.addEventListener('resize', updateEnd, { passive: true });

      track.addEventListener('click', function (e) {
        var a = e.target.closest('a.cplp-band__chip');
        if (!a) return;
        publish('callec:plp_upper_nav_click', {
          target_handle: a.dataset.handle || (a.getAttribute('href') || '').split('/').pop(),
          kind: a.dataset.kind || ''
        });
      });
    });
  }

  function initSupp(scope) {
    scope.querySelectorAll('[data-cplp-supp]').forEach(function (supp) {
      if (supp.dataset.cplpReady) return;
      supp.dataset.cplpReady = '1';
      var info = {
        source_handle: supp.dataset.source || '',
        mode: supp.dataset.mode || '',
        base_count: Number(supp.dataset.baseCount || 0),
        items: Number(supp.dataset.items || 0)
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (en) {
              if (en.isIntersecting) {
                publish('callec:plp_supplement_view', info);
                io.disconnect();
              }
            });
          },
          { threshold: 0.5 }
        );
        io.observe(supp.querySelector('.cplp-supp__head') || supp);
      }
      supp.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="/products/"]');
        if (!link) return;
        var item = link.closest('[data-cplp-supp-item]');
        if (!item) return;
        var items = Array.prototype.slice.call(supp.querySelectorAll('[data-cplp-supp-item]'));
        publish('callec:plp_supplement_click', {
          product_handle: item.dataset.handle || '',
          index: items.indexOf(item) + 1
        });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    initDesc(scope);
    initBand(scope);
    initSupp(scope);
  }

  window.__callecPlp = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* テーマエディターでセクションを差し替えたとき */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
